module.exports = __webpack_public_path__ + "fonts/e721a83e-fd4b-4dd9-82fd-76f3108e7e16.faa2c52f.ttf";